<template>
	<div class="Index">
		<div class="search">
			<router-link :to="{path:'/column/me'}" class="avatar">
				<img :src="userInfo.avatar" alt="">
			</router-link>
			<div class="search-input">
				<van-icon name="search" />
				<input type="text" placeholder="请输入搜索关键词" @focus="goSearch">
			</div>
			<!-- <div   class="attentiontBtn" @click="followChannel">{{followText}}</div> -->
		</div>
		<div class="swiper-img">
			<van-swipe :autoplay="3000" indicator-color="white">
					<van-swipe-item v-for="(item,index) in swiperImg" :key="index">
					  <img :src="item.image" alt="">
					</van-swipe-item>
			</van-swipe>
		</div>
		<div class="articles">
			<van-tabs v-model="active" color="#2880BB" title-inactive-color="#999" title-active-color="#333"  @change="changeTab">
				<van-tab :title="item.name"  v-for="(item,index) in channelsList" :key="index">
					<div class="content">
						<div class="titleWrap">
							<div class="title" v-for="(val,ind) in item.son" :key="val.id" :class="sonactive==ind?'active':''" @click="changeTitle(ind,val.id)">
									{{val.name}}
							</div>
							<!-- <span class="uppertrian" ref="uppertrian" :style="{transform:sonactive==0?'translate(-75%,-50%)':'translate(-25%,-50%)'}"></span> -->
						</div>
						<div class="list">
								<van-empty description="暂无数据哦..."  v-if="isEmpty"/>
								<row-item-list :list="articlesList" v-else></row-item-list>
						</div>
					</div>
				</van-tab>
			</van-tabs>
		</div>
	</div>
</template>
<script>
	import Banner from "@/components/Banner.vue";
    import Tabbar from '@/components/Tabbar.vue';
    import RowItemList from "@/components/RowItemList.vue"
    import {ModulesRecommend,InformationMenu,InformationDetails,ArticlesCollect,PersoanalUserInfo,IndexBanner,InformationSwiper} from "@/config/interface.js";
	export default{
		components:{
			Banner,
    		Tabbar,
    		RowItemList
		},
		data(){
			return{
                channel_id:0,
                swiperImg:[],     //轮播图
				userInfo:{},     //用户信息
				isEmpty:false,   //列表数据是否为空
				followText:'关注',
				type:6,
				active:0,           //tabbar的index
				sonactive:0,        //title默认的index
				articlesList:[],   //文章列表
				columnsList:[],    //专栏列表
				rotateLoading:false,        //换一批的icon状态
				channelsList:[],           //频道列表
				channel_id:0,         //频道id
				sonChannel_id:0,      //子频道id
				swiperOption: {
					direction: 'horizontal',
	                loop: true,
	                autoplay: 3000,
	                slidesPerView: "auto",
	                centeredSlides:true,
	                spaceBetween: 10,
			        pagination: {
			            el: '.swiper-pagination',
			            clickable: true
			        }
        		}
			}
		},
		beforeRouteEnter(to, from, next) {
            //  修复iOS版微信HTML5 History兼容性问题
            if (to.path !== location.pathname) {
                //console.log("检测完成")
                // 此处不可使用location.replace
                location.assign(to.fullPath)
            } else {
                next()
            }
        },
		mounted(){
			this.channel_id=this.$route.query.channel_id;
            this.sonChannel_id=this.$route.query.channel_id;
            // document.title='乐真血管—血管资讯';
            // let share_img=this.$route.query.share_img;
			// this.active=this.channel_id==21?2:0;      //MM学院默认第三个
			// let obj={
			// 	channel_id:this.channel_id
			// }
			// localStorage.setItem('channel_id',JSON.stringify(obj));
			this.getTitle();
            this.getChannels();
            this.getSwiper();

			this.getUserInfo();
            // common.wxShare(document.title,'',share_img);
		},
		watch:{
			    '$store.state.Loading':(newVal,oldVal)=>{
			      	this.loading=newVal;
			    }			
		},
		methods:{
			//获取用户信息
			getUserInfo(){
				const url=PersoanalUserInfo;
				let params={};
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.userInfo=data;
						 localStorage.setItem('userInfo',JSON.stringify(data));
           				 this.$store.dispatch('storageUserInfo',data);						
					}
				})
			},
			//跳转专栏详情
			skipColumnDetails(id){
				this.$router.push({
					path:'/column/details',
					query:{
						id:id
					}
				})
			},
			//频道目录
			getChannels(){
				const url=InformationMenu;
				let params={
					channel_id:this.channel_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						this.channelsList=res.data;
						this.sonChannel_id=res.data[0].son[0].id;
						this.getlist();
					}
				})
			},
			//关注频道
			followChannel(){
				const url=followChannels;
				let params={
					channel_id:this.channel_id
				}
				const method="POST";
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						this.followText=res.data.attach?'已关注':'关注';
					}
				})
				
            },
            //频道轮播图
            getSwiper(){
                const url=InformationSwiper;
                let params={
                   channel_id:this.sonChannel_id 
                }
                const method='POST';
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        var data=res.data;
                        this.swiperImg=data.images;
                    }
                })
            },
			//标题
			getTitle(){
				const url=InformationDetails;
				let params={
					channel_id:this.$route.query.channel_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						var data=res.data;
						if(data.channel&&data.channel.name){
							document.title=data.channel.name;
							if(common.is_weixin()){
								if(data.channel.share_img){
									common.wxShare(data.channel.name,data.channel.share_subtitle,data.channel.share_img);
								}
								else{
									common.wxShare(data.channel.name,data.channel.share_subtitle,this.$route.query.share_img);
								}
							}
						}
					}
				})
			},
			//列表
			getlist(){
				const url=InformationDetails;
				let params={
					channel_id:this.sonChannel_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						var data=res.data;
						this.articlesList=data.articles;
						this.isEmpty=data.articles.length==0?true:false;
						let follows=data.follows;
						this.articlesList.forEach((item,index)=>{
                            item.release_at=item.release_at==null?'':common.splitString(item.release_at,' ',0);
							this.$set(item,'isCollect',follows[String(item.id)]);
                        })
                     

					}
				})
			},
			//切换tab标签时触发
			changeTab(index,title){
                // console.log(index)
                console.log(this.channelsList[index])
				this.sonChannel_id=this.channelsList[index].son.length>0?this.channelsList[index].son[0].id:0;
				this.sonactive=0;
				this.getlist();
			},
			//切换标题
			changeTitle(index,id){
				this.sonactive=index;
				this.sonChannel_id=id;
				this.getlist();
			},
			
			//去搜索
			goSearch(){
				this.$router.push({
                    path:'../search/search',
                    query:{
                        channel_id:this.channel_id
                        }
                    })
			},
			//去选择城市
			selectCity(){
				this.$router.push({path:'/city/city'})
			}
		}
	}
</script>
<style lang="scss">
	.Index{
		//轮播
		.swiper-img{
			margin:0 auto;
			padding:0px 12px;
			/*width:350px;*/
			box-sizing:border-box;
			.van-swipe-item{
				img{
					width:100%;
					/*height:150px;*/
					border-radius:5px;
				}
			}
		}
		/*动画*/
		.rotate-active{
			animation: rotate-in 1s;
		}
		@keyframes rotate-in{
			0%{
				transform: rotate(0);
			}
			100%{
				transform: rotate(360deg);
			}
		}
		/*搜索*/
		.search{
			padding:8px 12px;
			@include flex(row);
			align-items:center;
			justify-content:space-between;
			.avatar{
				img{
					width:35px;
					height:35px;
					border-radius:100%;
				}
			}
			.search-input{
				@include flex(row);
				align-items:center;				
				flex:1;
				background: #F2F2F2;
				border: 1px solid #BFBFBF;
				border-radius: 16px;
				height:35px;
				padding:0px 5px;
				padding-left:10px;
				margin:0 8px;
				i{
					font-size:20px;
					color:#999;
				}
				input{
					flex:1;
					font-size:14px;
					color:#999;
					height:100%;
					padding-left:10px;
					background:transparent;
					border:0px;
				}
			}
			.attentiontBtn{
				width: 62px;
				height:35px;
				line-height:35px;
				font-size:14px;
				color:#fff;
				text-align: center;
				background: #FF504F;
				border-radius: 35px;
				border-radius: 35px;
			}
		}
		/*轮播图*/
		.swiper-img{
			img{
				border-radius:5px;
				width:100%;
				height:100%;
			}
		}
		.head{
			height:50px;
			line-height:50px;
			h3{
			font-size: 17px;
			color: #090909;
			letter-spacing: 0.6px;
			}	
		}
		.articles{
			.van-ellipsis{
				font-size:15px;
			}
			.van-tabs__nav{
				position: relative;
				z-index:6;
			}
			.content{
				width:94%;
				margin:18px auto;
				background: #FFFFFF;
				box-shadow: 0 0 9px 0 rgba(0,0,0,0.15);
				.titleWrap{
					position:relative;
					height:45px;
					line-height:45px;
					clear: both;
					div{
						float:left;
						width:56%;
						font-weight: bold;
    					letter-spacing: 1px;
						font-size:15px;
						text-align:center;
						background:#f4f4f4;
					}
					div.active{
						width:44%;
						background:#fff;
					}
					.uppertrian{
							position:absolute;
							left:50%;
							top:0;
							border-style: solid;
							border-color:transparent transparent #fff;
							border-width:45px;
							transform: translate(-75%,-50%);
    						z-index: 3;
						}
					div.active{
						background:#fff;
						color:#333	
					}
					
				}
				.list{
					height:410px;
					overflow: auto;
				}
			}
		}
		.van-overlay{
			display:block;
			z-index:100;
			.tip{
				width: 70%;
				position: absolute;
				right: 20px;
				top: 0;
			}
			.know{
				width:120px;
				position: absolute;
				bottom: 50px;
				left:50%;
				transform: translate(-50%,0);
				width:130px;
				
			}
		}

	}
</style>


// WEBPACK FOOTER //
// src/pages/Column/hospital.vue